import { ClickTrackingInfo } from "@omni/types/components/tracking/tracking-info/click/click.trackingInfo";

import { TypedAnalyticsEvent } from "@/services/tracking/types/analyticsEvent";

import { GoogleAnalyticsEvents } from "../GoogleAnalyticsEvents";
import {
    GoogleAnalyticsBannerImpression,
    getGoogleAnalyticsBannerImpression
} from "./GoogleAnalyticsBannerImpression";

export interface GoogleAnalyticsBannerClick
    extends GoogleAnalyticsBannerImpression {}

const getGoogleAnalyticsBannerClick = (
    data: TypedAnalyticsEvent<ClickTrackingInfo>
): GoogleAnalyticsBannerClick => {
    return getGoogleAnalyticsBannerImpression(
        data,
        GoogleAnalyticsEvents.BannerClick
    );
};

export { getGoogleAnalyticsBannerClick };
